<template>
  <a-row type="flex" justify="space-between">
    <a-col :span="24">
      <a-spin :spinning="loading">
        <a-table :columns="columnsListTable" :dataSource="logs" rowKey="id" :pagination="pagination">
        </a-table>
      </a-spin>
    </a-col>
  </a-row>
</template>

<script>
import utils from '../service/service.js'
export default {
  name: "logs",
  // props: {},
  mixins: [utils],
  data() {
    return {
      logs: [],
      loading: false,
      columnsListTable: [
        {
          title: "Fecha",
          dataIndex: "timestamp",
          width: "200px"
        },
        {
          title: "Log",
          dataIndex: "log",
        }, {
          title: "Usuario",
          dataIndex: "username",
        },
      ],
      pagination: { pageSize: 20 },
    };
  },
  mounted: function () {
    this.load();
  },
  methods: {

    async load() {
      this.loading = true;
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'logs/list',
      })
      this.loading = false;
      this.logs = data;
    },
  },
  computed: {}
};
</script>